import outputs from 'root/cfOutput'
import providers from 'root/src/shared/constants/providers'
import { authApiDomain } from 'root/src/shared/constants/authApi'

const { userPoolId } = outputs

export const refreshTokenValidity = 365

export const authApiBase = `https://${authApiDomain}`

// user can have multiple user groups
export const userGroups = {
	user: 'user',
	admin: 'admin',
	agency: 'agency',
	agencyAccountManager: 'agencyAccountManager',
	viewer: 'viewer',
	creator: 'creator',
	brand: 'brand',
	twitch: `${userPoolId}_${providers.twitch}`,
	youtube: `${userPoolId}_${providers.youtube}`,
}

// user can have only one role. it's calculated from user's groups
export const userRoles = [
	userGroups.user,
	userGroups.admin,
	userGroups.viewer,
	userGroups.creator,
	userGroups.brand,
	userGroups.agency,
	userGroups.agencyAccountManager,
]

export const authenticationTypes = {
	unauthenticated: 'unauthenticated',
	optional: 'optional',
	authenticated: 'authenticated',
}
// We can interpret these as tree nodes
// - when one node has another in an
// array, it means that it's its parent
export const authenticationPrecedence = {
	[authenticationTypes.optional]: [
		authenticationTypes.unauthenticated,
	],
	[authenticationTypes.authenticated]: [
		authenticationTypes.optional,
	],
	[authenticationTypes.unauthenticated]: [],
}
// ^^^^^^^^ same
export const groupsPrecedence = {
	[userGroups.admin]: [
		userGroups.creator,
		userGroups.brand,
		userGroups.twitch,
		userGroups.youtube,
		userGroups.agency,
	],
	[userGroups.creator]: [
		userGroups.viewer,
	],
	[userGroups.twitch]: [
		userGroups.viewer,
	],
	[userGroups.youtube]: [
		userGroups.viewer,
	],
	[userGroups.brand]: [
		userGroups.user,
	],
	[userGroups.viewer]: [
		userGroups.user,
	],
	[userGroups.agency]: [
		userGroups.agencyAccountManager,
	],
	[userGroups.agencyAccountManager]: [
		userGroups.user,
	],
	[userGroups.user]: [],
}
